import RightArrowWhiteIcon from "@/components/_icons/rightArrowWhiteIcon";
import Link from "next/link";
import { usePathname } from "next/navigation";
import clsx from "clsx";
import { ROUTE_CONFIRMATION } from "@/utils/constants";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";

const MerchantLinkButton = ({ merchantColor, uri, text }: any) => {
  const pathName = usePathname();
  const isConfirmationScreen = pathName === ROUTE_CONFIRMATION;
  return (
    <Link href={uri} className="focus-visible:ring-0">
      <div
        className={clsx(
          "text-sm text-white flex items-center w-full py-2 sm:px-3 md:px-8 bg-blue-700  data-[hover]:bg-blend-darken data-[active]:bg-blend-darken",
          {
            "rounded  px-2 ": isConfirmationScreen,
            "rounded-lg px-4": !isConfirmationScreen,
          }
        )}
        style={{ backgroundColor: merchantColor }}
        data-testid={
          isConfirmationScreen
            ? applyDataTestId(pom.confirmation.keepBrowsingButton)
            : undefined
        }
      >
        <span
          className={clsx("text-xs sm:text-sm text-nowrap", {
            "mr-2": isConfirmationScreen,
          })}
        >
          {text}
        </span>
        {isConfirmationScreen && <RightArrowWhiteIcon />}
      </div>
    </Link>
  );
};

export default MerchantLinkButton;
